import { TipoLotacao } from '@/modules/business/lotacoes/enums/tipo-lotacao.enum';
import { TipoLotacaoCompletaList } from '@/shared/constants/enumlist';

const VARIANTE_POR_TIPO_LOTACAO: Partial<Record<TipoLotacao, string>> = {
  [TipoLotacao.Titularidade]: 'success',
  [TipoLotacao.Designacao_Principal]: 'success',
  [TipoLotacao.Designacao]: 'info',
  [TipoLotacao.Designacao_Especial]: 'info',
  [TipoLotacao.Substituicao]: 'info',
  [TipoLotacao.Acumulacao]: 'warning',
};

/** Rótulo e cor do badge de titularidade a partir do tipo de lotação do relatório. */
export function getTitularidadeBadge(tipo: TipoLotacao | null): { label: string; variant: string } {
  const label = TipoLotacaoCompletaList.find((item) => item.value === tipo)?.name;

  if (tipo === null || !label) {
    return { label: 'Não definido', variant: 'secondary' };
  }

  return { label, variant: VARIANTE_POR_TIPO_LOTACAO[tipo] ?? 'secondary' };
}
